/**
 * Mouton Library — storefront JS
 */
(function () {
  function initHeader(root) {
    var toggle = root.querySelector('[data-mouton-nav-toggle]');
    var drawer = root.querySelector('[data-mouton-nav-drawer]');
    if (!toggle || !drawer) return;

    function setOpen(isOpen) {
      drawer.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.documentElement.classList.toggle('mouton-nav-open', isOpen);
    }

    toggle.addEventListener('click', function () {
      setOpen(!drawer.classList.contains('is-open'));
    });

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        setOpen(false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  function initBanner(root) {
    var track = root.querySelector('[data-mouton-banner-track]');
    var slides = root.querySelectorAll('[data-mouton-banner-slide]');
    if (!track || slides.length < 2) return;

    var prev = root.querySelector('[data-mouton-banner-prev]');
    var next = root.querySelector('[data-mouton-banner-next]');
    var dotsWrap = root.querySelector('[data-mouton-banner-dots]');
    var index = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function slideWidth() {
      return slides[0].getBoundingClientRect().width + 14;
    }

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slideWidth() * index, behavior: reduceMotion ? 'auto' : 'smooth' });
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.ml-banner__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ml-banner__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        btn.addEventListener('click', function () {
          stop();
          goTo(i);
          start();
        });
        dotsWrap.appendChild(btn);
      });
    }

    function start() {
      if (!autoplay || reduceMotion || slides.length < 2) return;
      stop();
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, interval);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        stop();
        goTo(index - 1);
        start();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        stop();
        goTo(index + 1);
        start();
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        var i = Math.round(track.scrollLeft / slideWidth());
        if (i !== index && i >= 0 && i < slides.length) {
          index = i;
          updateDots();
        }
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    buildDots();
    start();
  }

  function init() {
    document.querySelectorAll('[data-mouton-header]').forEach(initHeader);
    document.querySelectorAll('[data-mouton-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('[data-mouton-header]');
    if (header) initHeader(header);
    var banner = event.target.querySelector('[data-mouton-banner]');
    if (banner) initBanner(banner);
    if (event.target.matches && event.target.matches('[data-mouton-banner]')) {
      initBanner(event.target);
    }
  });
})();
